document.addEventListener('DOMContentLoaded', () => {
	/* Open/Close */
	/* -------------------------------------------------------------------------------------- */
	$('body').on('click', '[js-open-item]', function(event) {
			event.preventDefault();
			/* Act on the event */
			var el = $(this),
				item = $(el.attr('data-open'));
			item.addClass('active');
	});

	$('body').on('click', '[js-close-item]', function(event) {
			event.preventDefault();
			/* Act on the event */
			var el = $(this),
				item = $(el.attr('data-close'));
			item.removeClass('active');
	});

	$('body').on('click', '[js-toggle-item]', function(event) {
			event.preventDefault();
			/* Act on the event */
			var el = $(this),
				item = $(el.attr('data-toggle'));
			item.toggleClass('active');
			el.toggleClass('active');
	});
});